/**
 * @generated SignedSource<<a1b5dfc6c8a5d76a286ad9a09afe5578>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TemplateListNewPaneFooter$data = {
  readonly templateTreeUrl: string;
  readonly viewerCanPush: boolean;
  readonly viewerIssueCreationPermissions: {
    readonly triageable: boolean;
    readonly typeable: boolean;
  };
  readonly " $fragmentType": "TemplateListNewPaneFooter";
};
export type TemplateListNewPaneFooter$key = {
  readonly " $data"?: TemplateListNewPaneFooter$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateListNewPaneFooter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateListNewPaneFooter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueCreationPermissions",
      "kind": "LinkedField",
      "name": "viewerIssueCreationPermissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "typeable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "triageable",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateTreeUrl",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "e24bc836feef3fb43015ed2024d9e24a";

export default node;
